import { network } from 'services/network';

export const changePassword = (params) => {
    return network.post('admin/bo/changePassword', params).then((response) => {
        return response.status;
    });
};
